import React, { useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";

import { toast } from "react-toastify";
import Pagination from "../../../../components/Pagination";
import { Modal as AntModal, Spin } from "antd";

import Modal from "react-modal";

const SortingGradingListview = (props) => {
  const [loading, setLoading] = useState({
    approve: false,
    disapprove: false,
    sendNextApprove: false,
  });
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);
  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "60%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px", // Adjust the width as needed
      height: "80%",
      minHeight: "450px",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const [gradeDetails, setGradeDetails] = useState([]);
  const { addForm, update, sId } = props;
  const [data, setData] = useState([]);
  const [sgData, setSgData] = useState([]);
  const [allData, setAllData] = useState([]);

  const { sendRequest: getsortingGrading } = useHttp();

  const getData = () => {
    getsortingGrading(
      {
        url: "/api/sortingGrading/",
      },
      (res) => {
        if (res) {
          //  //console.log(res);
          const sortedData = res.sort(
            (a, b) => b.sortingGradingId - a.sortingGradingId
          );
          setData(sortedData);

          setSgData(res[0]);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);

  const openModal = (data) => {
    setSelectedData(data);

    const id = (data && data.sortingGradingId) || "";
    //console.log(id);

    getsortingGrading(
      {
        url: `/api/sortingGrading/?sortingGradingId=${id}`,
      },
      (res) => {
        setGradeDetails(res.productDetail);
      }
    );
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.sortingGradingNo.includes(filetrtext) ||
        item.employeeName.includes(filetrtext) ||
        item.lotNo.includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const { sendRequest: sgDelete } = useHttp();

  const deleteOperation = (e, sortingGradingId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete these detail?",
      onOk() {
        setDeleteLoading(sortingGradingId);
        const data = {
          sortingGradingId: sortingGradingId,
          serviceId: sId,
        };

        sgDelete(
          {
            url: "/api/sortingGrading/",
            method: "DELETE",
            body: data,
          },
          (data) => {
            toast.success("Data Deleted Successfully");
            getData();
            setDeleteLoading(false);
          },
          () => {
            setDeleteLoading(false);
          }
        );
      },
      onCancel() {
        setDeleteLoading(false);
      },
    });
  };
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [selectedApprovalData, setSelectedApprovalData] = useState(null);
  const [approvalPopupVisible, setApprovalPopupVisible] = useState(false);

  const [remark, setRemark] = useState("");

  const { sendRequest: updateApprovalStatus } = useHttp();

  const showApprovalPopup = (expense) => {
    console.log(expense);
    setSelectedApprovalData(expense);
    setApprovalPopupVisible(true);
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };

  const handleApprovalSubmit = (status) => {
    const approvalStatus = status || "";

    setLoading((prevState) => ({ ...prevState, [status]: true }));
    let data = "";
    const getApprovalData = (approvalStatus) => {
      const baseData = {
        itemId: selectedApprovalData && selectedApprovalData.sortingGradingId,

        approvedBy: parseInt(localStorage.getItem("empId")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: localStorage.getItem("orgId"),
        remark: remark,
      };

      switch (approvalStatus) {
        case "approve":
          return { ...baseData, approved: 1 };
        case "disapprove":
          return { ...baseData, approved: 2 };
        case "sendNextApprove":
          return { ...baseData, approved: 0, nextlevel: 1 };
        default:
          return baseData;
      }
    };

    data = getApprovalData(approvalStatus);

    updateApprovalStatus(
      {
        url: "/api/approveSortingGrading/",
        method: "PUT",
        body: data,
      },
      (data) => {
        toast.success(data);

        setApprovalPopupVisible(false);
        setRemark("");
        getData();
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
      },
      () => {
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
      }
    );
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Sorting and Grading</label>
          </div>

          <div className="col-6 text-right">
            {canAdd === "block" && (
              <button
                type="button"
                className="btn  btn-primary mx-3 my-3"
                onClick={() => {
                  addForm(true);
                  sId(serviceId);
                  update(false);
                }}
              >
                Add Sorting/Grading
              </button>
            )}
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-4"> </div>

                      <div className="col-4">
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />
                      </div>
                    </div>
                    <br />
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Doc No</th>
                          <th>Lot No</th>
                          <th>Assigned Supervisor</th>
                          <th>Total input Weight</th>
                          <th>Disposal in Weight</th>
                          <th>Approval</th>

                          {canView === "block" && <th>View</th>}
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.sortingGradingDate}</td>
                                <td>{itm.sortingGradingNo}</td>
                                <td>{itm.lotNo}</td>
                                <td>{itm.employeeName}</td>
                                <td>
                                  {itm.totalInputWeight +
                                    " " +
                                    itm.unitAbbreviation}
                                </td>
                                <td>
                                  {itm.diseasedDamagedWeight +
                                    " " +
                                    itm.diseasedUnitAbbreviation}
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    type="button"
                                    onClick={() => showApprovalPopup(itm)}
                                    disabled={
                                      itm.nextlevel == 1
                                        ? itm.allowApproveUserId == loginUserId
                                          ? false
                                          : true
                                        : itm.approved == 0 &&
                                          itm.reportingId == loginUserId
                                        ? false
                                        : true
                                    }
                                  >
                                    {itm.approved == 1 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "green" }}
                                      ></i>
                                    ) : itm.approved == 2 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "red" }}
                                      ></i>
                                    ) : (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "gray" }}
                                      ></i>
                                    )}
                                  </button>
                                </td>
                                {/* <td>
                                  <button
                                    onClick={() => {
                                      props.addForm(true);
                                      props.update(itm);
                                      props.sId(serviceId)
                                    }}
                                    className="btn"
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>*/}
                               <td>
                                  {deleteLoading === itm.sortingGradingId ? (
                                    <Spin />
                                  ) : (
                                    <button
                                      onClick={(e) =>
                                        deleteOperation(e, itm.sortingGradingId)
                                      }
                                      className="btn"
                                    >
                                      <i className="fa fa-trash"></i>
                                    </button>
                                  )}
                                </td>
                                {canView === "block" && (
                                  <td>
                                    <button
                                      className="btn"
                                      onClick={() => openModal(itm)}
                                    >
                                      <i className="fas fa-eye"></i>
                                    </button>
                                  </td>
                                )}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* view modal */}
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div className="mx-2">
            <div className="">
              <h3 className="card-title">Sorting and Grading Details</h3>
              <div className="card-tools text-right">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="remove"
                  onClick={() => setIsModalOpen(false)}
                >
                  <i className="fas fa-times" />
                </button>
                <hr />
              </div>
            </div>

            <div className="row ">
              <p className="col-md-6">
                Sorting Grading Date: {selectedData.sortingGradingDate}
              </p>
              <p className="col-md-6">
                Assigned Supervisor: {selectedData.employeeName}
              </p>
            </div>
            <div className="row ">
              <p className="col-md-6">Doc No: {selectedData.lotNo}</p>

              <p className="col-md-6">
                Total Input Weight:{" "}
                {selectedData.totalInputWeight +
                  "  " +
                  selectedData.unitAbbreviation}
              </p>
            </div>

            <div className="row ">
              <p className="col-md-6">
                Sized Count(60-70mm): {selectedData.sizedCount}
              </p>
              <p className="col-md-6">
                Oversized Count(70-80mm): {selectedData.overSizedCount}
              </p>
            </div>

            <div className="row ">
              <p className="col-md-6">
                Under Sized Count(50-60mm): {selectedData.underSizedCount}
              </p>
              <p className="col-md-6">
                Immature/Scarred/Blemished Count: {selectedData.immatureCount}
              </p>
            </div>
            <div className="row ">
              <p className="col-md-6">
                Diseased damaged Count: {selectedData.diseasedDamagedCount}
              </p>
              <p className="col-md-6">
                Diseased damaged disposal in Weight:{" "}
                {selectedData.diseasedDamagedWeight +
                  " " +
                  selectedData.diseasedUnitAbbreviation}
              </p>
            </div>

            <h5 className="card-title">Grades Details</h5>
            <div className="text-center">
              <table className="table table-bordered table-sm">
                <thead>
                  <tr className="tableheaderrowview">
                    <th>Sr.No.</th>
                    <th>Product Name</th>
                    <th>Item Id</th>
                    <th>Product Sub Type</th>
                    <th>Product Type</th>
                    <th>Grade Name</th>
                    <th>Item Quantity</th>
                    <th>Unit</th>
                  </tr>
                </thead>
                <tbody>
                  {gradeDetails &&
                    gradeDetails.map((itm, i) => {
                      return (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{itm.productName}</td>
                          <td>{itm.itemId}</td>
                          <td>{itm.productSubTypeName}</td>
                          <td>{itm.productTypeName}</td>
                          <td>{itm.gradeName}</td>
                          <td>{itm.itemQuantity}</td>
                          <td>{itm.unitAbbreviation}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </Modal>

      <AntModal
        title="Sorting Grading Approval"
        open={approvalPopupVisible}
        onCancel={() => setApprovalPopupVisible(false)}
        footer={null}
      >
        <label>Remarks:</label>
        <textarea
          rows={3}
          value={remark}
          className="form-control"
          onChange={handleRemarkChange}
        />
        <br />
        <div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("approve")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.approve ? "Approving..." : "Approve"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={() => handleApprovalSubmit("disapprove")}
            className="btn btn-sm btn-primary"
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.disapprove ? "Disapproving..." : "Disapprove"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("sendNextApprove")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.sendNextApprove ? "Sending..." : "Send Next Approve"}
          </button>
        </div>
      </AntModal>
    </>
  );
};

export default SortingGradingListview;
